import { Alert, Card, CardBody } from "reactstrap";
import WizardPanel from "../WizardPanel";
import ServerPicker from "../shared/ServerPicker";

/**
 * @param {import("../WizardCard").StepPanelProps} props
 *
 * Lets the user search reachable servers and assign one to the installation.
 */
export default function AssetSelectionPanel({ installation, setField, status, bottomNav }) {
  const mode = installation?.is_cloud === false ? "onprem" : "cloud";
  const assignedHostname = installation?.server_name ?? "";

  return (
    <WizardPanel
      title="Asset Selection"
      subtitle="Search and assign the NUC inference server shipped to this store"
      status={status}
      bottomNav={bottomNav}
    >
      {assignedHostname ? (
        <Alert color="success" className="mb-3">
          <i className="fas fa-check-circle mr-2" />
          Currently assigned to <strong>{assignedHostname}</strong>
        </Alert>
      ) : (
        <Alert color="info" className="mb-3">
          <i className="fas fa-info-circle mr-2" />
          No server assigned yet — search a reachable hostname below.
        </Alert>
      )}

      <Card>
        <CardBody>
          <ServerPicker
            value={assignedHostname}
            mode={mode}
            onSelect={(hostname) => setField("server_name", hostname)}
          />
        </CardBody>
      </Card>
    </WizardPanel>
  );
}
